export default "__VITE_ASSET__497ea9c5__"